import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { VasState } from '../../store/store-type';
import * as jobActions from './job.actions';

@Injectable()
export class JobsSideEffects {

    protected _syncJobTimeout: any;

    @Effect()
    setFilter$: Observable<Action> = this.actions$
        .ofType(jobActions.SET_FILTER)
        .map(() => {
            return new jobActions.SyncJobsEnqueueAction();
        });

    @Effect()
    loadNextPage$: Observable<Action> = this.actions$
        .ofType(jobActions.LOAD_NEXT_PAGE)
        .map(() => {
            return new jobActions.SyncJobsEnqueueAction();
        });

    @Effect({dispatch: false})
    syncJobsEnqueue$ = this.actions$
        .ofType(jobActions.SYNC_JOBS_ENQUEUE)
        .do(() => {
            clearTimeout(this._syncJobTimeout);
            this._syncJobTimeout = setTimeout(() => {
                this.store.dispatch(new jobActions.SyncJobsAction());
            }, 500);
        });

    @Effect({dispatch: false})
    syncJobs$ = this.actions$
        .ofType(jobActions.SYNC_JOBS)
        .switchMap(() => {
            return this.appFacade.whenAppReady()
                .take(1)
                .do(() => this.appFacade.objects.job.store.setUiLoading(
                    true
                ))
                .concatMap(() =>
                    this.appFacade.objects.account.store.getActive()
                        .take(1)
                        .concatMap(account => {
                            // only sync jobs (using the pagination model) if
                            // there is an account selected
                            return !account ?
                                of(undefined) :
                                this.appFacade.objects.job.syncAll(
                                    undefined,
                                    account.id
                                );
                        })
                )
                .do(() => this.appFacade.objects.job.store.setUiLoading(
                    false
                ))
                .catch(error => {
                    this.appFacade.objects.job.store.setUiLoading(false);
                    return this.appFacade.toast.toastDanger(error);
                });
        });

    constructor(
        protected actions$: Actions,
        protected store: Store<VasState>,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/jobs.side-effects.ts